import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';

const env = import.meta.env.MODE;
const enabledEnvs = ['production', 'staging'];

export const initializeSentry = () => {
  if (!enabledEnvs.includes(env)) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: (integrations) =>
      integrations.filter(
        (integration) => integration.name !== 'GlobalHandlers'
      ),
    environment: env,
    sendDefaultPii: true,
    beforeSend(event, hint) {
      const exception = event?.exception?.values?.[0];
      const original = hint.originalException;

      if (original instanceof AxiosError) {
        const message = original.message;
        const method = original.config?.method?.toUpperCase() ?? '';
        const endpoint = original.config?.url;
        const status = original.response?.status ?? 0;

        if (exception) {
          exception.type = `API Error [${status}]: ${method} ${endpoint}`;
          exception.value = message;
        }
      }
      return event;
    },
    beforeBreadcrumb: (breadcrumb) => {
      const isConsoleBreadcrumb = breadcrumb.category === 'console';
      if (isConsoleBreadcrumb) return null;
      return breadcrumb;
    },
  });
};
